import { Lock } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

export function TrialLockedBotNotice({
  trialExpired,
  onViewPlans,
}: {
  trialExpired: boolean;
  onViewPlans: () => void;
}) {
  return (
    <Alert className="border-primary/20 bg-primary/[0.04]">
      <Lock className="h-4 w-4" />
      <AlertTitle>Available with Intelligence</AlertTitle>
      <AlertDescription className="space-y-3">
        <p>
          {trialExpired
            ? "Your trial has ended. Your previous conversations and Leadership Record are still available."
            : "Your previous conversations and Leadership Record are still available. New Coach Veera messages require Intelligence."}
        </p>
        <Button type="button" size="sm" onClick={onViewPlans}>
          View plans
        </Button>
      </AlertDescription>
    </Alert>
  );
}
